import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hiddenField", "chipContainer", "autocompleteInput"]

  connect() {
    console.log('Multi-vendor-select controller connected!')
    this.selectedVendors = []
    this.loadExistingVendors()

    // Listen for preset-loaded event
    document.addEventListener('preset-loaded', this.handlePresetLoaded.bind(this))
  }

  disconnect() {
    document.removeEventListener('preset-loaded', this.handlePresetLoaded.bind(this))
  }

  loadExistingVendors() {
    const existingIds = this.hiddenFieldTarget.value
    if (existingIds) {
      try {
        this.selectedVendors = JSON.parse(existingIds)
      } catch(e) {
        this.selectedVendors = []
      }
    }
  }

  handlePresetLoaded(event) {
    console.log('Preset loaded event received', event.detail)
    const vendors = event.detail.vendors
    console.log('Vendors to load:', vendors)

    if (!vendors || vendors.length === 0) {
      console.log('No vendors to load')
      return
    }

    // Clear existing chips
    this.chipContainerTarget.innerHTML = ''
    this.selectedVendors = []

    // Add vendors with their names
    vendors.forEach(vendor => {
      console.log('Adding vendor:', vendor)
      this.selectedVendors.push(parseInt(vendor.id))
      this.addChip(vendor.id, vendor.name)
    })

    this.updateHiddenField()
    console.log('Final selectedVendors:', this.selectedVendors)
  }

  addVendor(event) {
    console.log('addVendor called', event)
    console.log('event.detail:', event.detail)

    // Check if this is the vendor autocomplete by looking for the input inside our element
    const autocompleteInput = this.element.querySelector('#vendor_autocomplete')
    if (!autocompleteInput) {
      console.log('Vendor autocomplete input not found in this element, ignoring')
      return
    }

    const vendorId = event.detail.value
    console.log('Vendor ID:', vendorId)

    // Try to get the vendor name from the autocomplete results
    let vendorName = event.detail.textValue
    if (!vendorName) {
      const resultsList = this.element.querySelector('[data-autocomplete-target="results"]')
      const selectedItem = resultsList?.querySelector(`[data-autocomplete-value="${vendorId}"]`)
      vendorName = selectedItem?.dataset.autocompleteText || selectedItem?.textContent?.trim() || `Vendor ${vendorId}`
    }
    console.log('Vendor name:', vendorName)

    if (!vendorId || this.selectedVendors.includes(parseInt(vendorId))) {
      console.log('Already selected or no ID, skipping')
      return
    }

    console.log('Adding vendor to list')
    this.selectedVendors.push(parseInt(vendorId))
    this.updateHiddenField()
    this.addChip(vendorId, vendorName)
    this.clearAutocomplete()
  }

  removeVendor(event) {
    const vendorId = parseInt(event.currentTarget.dataset.vendorId)
    this.selectedVendors = this.selectedVendors.filter(id => id !== vendorId)
    this.updateHiddenField()
    event.currentTarget.parentElement.remove()

    // Show "no vendors selected" message if no vendors remain
    if (this.selectedVendors.length === 0) {
      const noVendorsMessage = document.getElementById('no-vendors-message')
      if (noVendorsMessage) {
        noVendorsMessage.style.display = 'block'
      }
    }
  }

  updateHiddenField() {
    this.hiddenFieldTarget.value = JSON.stringify(this.selectedVendors)
  }

  addChip(vendorId, vendorName) {
    // Hide "no vendors selected" message if it exists
    const noVendorsMessage = document.getElementById('no-vendors-message')
    if (noVendorsMessage) {
      noVendorsMessage.style.display = 'none'
    }

    const chip = document.createElement('span')
    chip.className = 'badge bg-primary me-2 mb-2'
    chip.style.fontSize = '0.9rem'
    chip.innerHTML = `
      ${vendorName}
      <button type="button"
              class="btn-close btn-close-white ms-2"
              style="font-size: 0.7rem"
              data-vendor-id="${vendorId}"
              data-action="click->multi-vendor-select#removeVendor">
      </button>
    `
    this.chipContainerTarget.appendChild(chip)
  }

  clearAutocomplete() {
    if (this.hasAutocompleteInputTarget) {
      this.autocompleteInputTarget.value = ''

      // Clear the hidden autocomplete value field
      const autocompleteController = this.application.getControllerForElementAndIdentifier(
        this.autocompleteInputTarget.closest('[data-controller~="autocomplete"]'),
        'autocomplete'
      )
      if (autocompleteController && autocompleteController.hasHiddenTarget) {
        autocompleteController.hiddenTarget.value = ''
      }
    }
  }
}
